import React from 'react';
import KPISet from '../components/KPISet';
import KPICards from '../components/KPICards';

const dataProviderName = 'campaigns/campaignoperation';
//KPICards TORNA COME LISTA CON ELEMENTO INTERNO diverso. List -> chiama KPICards
const Default = () => {
    const now = new Date();
    const startOfYear = new Date(`${now.getFullYear()}-01-01`);
    const defaultFilters = {
        items: []
    };

    return <>
        <KPISet dataProviderName={dataProviderName} filters={defaultFilters} /> 
        <KPICards dataProviderName={dataProviderName} filters={defaultFilters} />
    </>

}

export default Default;